import styled from "styled-components";

import { useMobile } from "hooks";
import { FlexColumn, FlexContainer, SectionLarge } from "styles";

import MediaSlot from "../MediaSlot/MediaSlot";
import MobilePreview from "../MobilePreview/MobilePreview";

const Row = styled(SectionLarge)`
	width: 100%;
	align-items: center;

	@media (max-width: 900px) {
		flex-direction: column;
		align-items: center;
	}
`;

const Copy = styled(FlexColumn)`
	height: 100%;
	display: flex;
	justify-content: center;
	flex: 2;
	min-width: 0;
	width: 100%;

	@media (max-width: 900px) {
		flex: none;
	}
`;

export default function FeatureRow({
	children,
	footer,
	invert,
	phone,
	videoUrl,
	imageUrl,
	mediaSrc,
	mediaLabel,
	mediaHint,
	mediaAlt,
	mediaMaxWidth,
	dark,
	cover,
	fit
}) {
	const isMobile = useMobile();
	const fill = cover || fit;
	const mediaWidth = mediaMaxWidth || (isMobile ? 420 : undefined);

	const media = (
		<FlexContainer
			style={{
				flex: 1,
				minWidth: isMobile ? 0 : mediaMaxWidth ? 0 : 280,
				maxWidth: mediaWidth || "none",
				width: mediaMaxWidth ? "100%" : undefined,
				alignItems: fill ? "stretch" : "center",
				alignSelf: fill ? "stretch" : undefined
			}}
		>
			{phone ? (
				<MobilePreview videoUrl={videoUrl} imageUrl={imageUrl} alt={mediaAlt} />
			) : (
				<div style={{ width: "100%", height: fill ? "100%" : undefined, padding: isMobile ? "10px 0" : "24px" }}>
					<MediaSlot
						src={mediaSrc}
						label={mediaLabel}
						hint={mediaHint}
						alt={mediaAlt}
						dark={dark}
						cover={cover}
						fit={fit}
					/>
				</div>
			)}
		</FlexContainer>
	);

	return (
		<Row>
			{!isMobile && !invert && media}
			<Copy>
				{children}
				{!isMobile && footer}
				{isMobile && media}
				{isMobile && footer}
			</Copy>
			{!isMobile && invert && media}
		</Row>
	);
}
